<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        {{ temoignage ? 'Modifier' : 'Ajouter' }} un témoignage
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-column ma-3 mt-10">
      <v-textarea
        v-model="temoignageModifiable.prenomAdherent"
        :disabled="loading"
        :rules="[rules.required]"
        auto-grow
        class="mb-4"
        counter="50"
        label="Prénom de l'adhérent"
        maxlength="50"
        outlined
        required
        rows="1"
      />
      <v-textarea
        v-model="temoignageModifiable.nomAdherent"
        :disabled="loading"
        :rules="[rules.required]"
        auto-grow
        class="mb-4"
        counter="50"
        label="Nom de l'adhérent"
        maxlength="50"
        outlined
        required
        rows="1"
      />
      <v-textarea
        v-model="temoignageModifiable.lieuExploitation"
        :disabled="loading"
        :rules="[rules.required]"
        auto-grow
        class="mb-4"
        counter="70"
        label="Lieu de l'exploitation de l'adhérent"
        maxlength="70"
        outlined
        required
        rows="1"
      />
      <v-textarea
        v-model="temoignageModifiable.texteTemoignage"
        :disabled="loading"
        :rules="[rules.required]"
        auto-grow
        class="mb-4"
        counter="300"
        label="Texte du témoignage"
        maxlength="300"
        outlined
        required
        rows="1"
      />
      <v-file-input
        v-model="fichierPhoto"
        accept=".png,.jpg"
        class="mb-4"
        label="Image de l'adhérent"
        prepend-icon="mdi-account"
        show-size
        @change="onPhotoChange"
      />
      <AgrialCheckbox
        v-model="temoignageModifiable.isActif"
        :disabled="loading"
        label="Témoignage actif"
      />
    </div>
    <div class="d-flex justify-space-around">
      <AgrButton
        :disabled="loading"
        class="pa-5"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        :disabled="isBoutonValiderDisabled"
        class="pa-5"
        @click="enregistrerTemoignage()"
      >
        Valider
      </AgrButton>
    </div>
  </v-card>
</template>

<script>
import {mapActions} from 'vuex'
import {AgrButton} from '@agrial/ui'
import {clone} from '@/utils/clone'
import AgrialCheckbox from '@/components/form/agrial-checkbox.vue'
import {getFileFromBase64} from '@/utils/fichier'

export default {
  name: 'EditTemoignageAbonnementModal',
  components: {AgrialCheckbox, AgrButton},
  props: {
    temoignage: {
      type: Object,
      default: null
    },
  },

  data () {
    return {
      loading: false,
      erreur: false,
      temoignageModifiable: {
        prenomAdherent: null,
        nomAdherent: null,
        lieuExploitation: null,
        texteTemoignage: null,
        isActif: true,
        photo: null,
      },
      fichierPhoto: null,
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis',
      },
    }
  },

  computed: {
    isBoutonValiderDisabled () {
      return this.loading || this.temoignageModifiable.prenomAdherent === null || this.temoignageModifiable.prenomAdherent === '' ||
        this.temoignageModifiable.nomAdherent === null || this.temoignageModifiable.nomAdherent === '' ||
        this.temoignageModifiable.lieuExploitation === null || this.temoignageModifiable.lieuExploitation === '' ||
        this.temoignageModifiable.texteTemoignage === null || this.temoignageModifiable.texteTemoignage === ''
    }
  },

  created () {
    if (this.temoignage) {
      this.temoignageModifiable = clone(this.temoignage)
      this.fichierPhoto = getFileFromBase64(this.temoignage.photo.filename, this.temoignage.photo.type, this.temoignage.photo.contenu)
    }
  },

  methods: {
    ...mapActions({
      updateTemoignageAbonnement: 'temoignageAbonnement/updateTemoignageAbonnement'
    }),

    enregistrerTemoignage () {
      this.loading = true
      this.erreur = false

      this.updateTemoignageAbonnement(this.temoignageModifiable)
        .then(() => this.$emit('close'))
        .catch(() => this.erreur = true)
        .finally(() => this.loading = false)
    },

    onClose () {
      this.$emit('close')
    },

    async onPhotoChange (fichierBrut) {
      if (fichierBrut) {
        const contenuBase64 = await this.getFileContent(fichierBrut)
        this.temoignageModifiable.photo = {
          filename: fichierBrut.name,
          type: fichierBrut.type,
          contenu: contenuBase64.split(',')[1] // on ne prend que la partie chiffrée (l'entête fait bugué le décodage dans le back)
        }
      } else {
        this.temoignageModifiable.photo = null
      }

    },

    async getFileContent (fichier) {
        return await new Promise((resolve) => {
          let fileReader = new FileReader()
          fileReader.onload = () => resolve(fileReader.result)
          fileReader.readAsDataURL(fichier)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.input-number {
  width: 100%;
}
</style>
